var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hkl-header" }, [
    _c("div", { staticClass: "hkl-header-left" }, [
      _c(
        "a",
        {
          staticClass: "hkl-header-back",
          class: _vm.linkClassLeftPrimary,
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onLeftPrimaryClick.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n      < " + _vm._s(_vm.labelLeftPrimary) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.labelLeftSecondary
        ? _c(
            "a",
            {
              staticClass: "hkl-header-link",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onLeftSecondaryClick.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n      < " + _vm._s(_vm.labelLeftSecondary) + "\n    ")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showRightCluster
      ? _c("div", { staticClass: "hkl-header-right" }, [
          _vm.labelRightLeading
            ? _c(
                "a",
                {
                  staticClass: "hkl-header-link",
                  class: { "hkl-header-link--disabled": _vm.shouldDisablePrev },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onRightLeadingClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      < " + _vm._s(_vm.labelRightLeading) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.labelRightTrailing
            ? _c(
                "a",
                {
                  staticClass: "hkl-header-link",
                  class: { "hkl-header-link--disabled": _vm.shouldDisableNext },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onRightTrailingClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.labelRightTrailing) + " >\n    "
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }